import { defineNuxtPlugin } from 'nuxt/app'
import vWebp from '~/directives/v-webp'
import vWebpSize from '~/directives/v-webpsize'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.directive('webp', vWebp)
  nuxtApp.vueApp.directive('webpsize', vWebpSize)
})
